export default __webpack_public_path__ + "static/home-illustration-eddfa51a1d67f7c83dfacb039875f0be.png";